// OE or non-OE, fixed per opening so a refetch blip in hasEhrBooking cannot swap the form under the user.

import { useState } from 'react'

type Args = {
  open: boolean
  appointmentId?: number
  hasEhrBooking?: boolean
}

type Latch = {
  key: string
  isEmr: boolean
}

export const openingKeyFor = (open: boolean, appointmentId?: number): string =>
  open ? `open-${appointmentId ?? 'new'}` : 'closed'

// The opening's mode is returned in the same pass that detects it, so memos built from it are never stale.
export const useDialogMode = ({ open, appointmentId, hasEhrBooking }: Args) => {
  const openingKey = openingKeyFor(open, appointmentId)
  const [latch, setLatch] = useState<Latch>({ key: openingKey, isEmr: Boolean(hasEhrBooking) })

  const isNewOpening = open && openingKey !== latch.key
  const isEmr = isNewOpening ? Boolean(hasEhrBooking) : latch.isEmr

  if (openingKey !== latch.key) setLatch({ key: openingKey, isEmr })

  return { isEmr, openingKey }
}
